// openEHR LANG model — BMM package org.openehr.lang.bmm.core.literal_value
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import type { BMM_SIMPLE_TYPE, BMM_TYPE, BMM_UNITARY_TYPE, T } from "../../_shared.ts";
import * as openehr_base from "../../../base/mod.ts";

/**
 * Meta-type for literal instance values declared in a model. Instance values may be inline values of primitive types in the usual fashion or complex objects in syntax form, e.g. JSON.
 */
export abstract class BMM_LITERAL_VALUE<T extends BMM_TYPE> {
  /**
   * Internal storage for value_literal
   * @protected
   */
  protected _value_literal?: openehr_base.String;

  /**
   * A serial representation of the value.
   */
  get value_literal(): string | undefined {
    return this._value_literal?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for value_literal.
   * Use this to access openehr_base.String methods.
   */
  get $value_literal(): openehr_base.String | undefined {
    return this._value_literal;
  }

  /**
   * Sets value_literal from either a primitive value or openehr_base.String wrapper.
   */
  set value_literal(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._value_literal = undefined;
    } else if (typeof val === "string") {
      this._value_literal = openehr_base.String.from(val);
    } else {
      this._value_literal = val;
    }
  }

  /**
   * A native representation of the value, possibly derived by deserialising \`_value_literal_\`.
   */
  value?: openehr_base.Any;
  /**
   * Internal storage for syntax
   * @protected
   */
  protected _syntax?: openehr_base.String;

  /**
   * Optional specification of formalism of the \`_value_literal_\` attribute for complex values. Value may be any of \`json | json5 | yawl | xml | odin | rdf\` or another value agreed by the user community. If not set, \`json\` is assumed.
   */
  get syntax(): string | undefined {
    return this._syntax?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for syntax.
   * Use this to access openehr_base.String methods.
   */
  get $syntax(): openehr_base.String | undefined {
    return this._syntax;
  }

  /**
   * Sets syntax from either a primitive value or openehr_base.String wrapper.
   */
  set syntax(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._syntax = undefined;
    } else if (typeof val === "string") {
      this._syntax = openehr_base.String.from(val);
    } else {
      this._syntax = val;
    }
  }

  /**
   * Concrete type of this literal.
   */
  type?: T;
}

/**
 * Meta-type for literals whose concrete type is a unitary type in the BMM sense.
 */
export abstract class BMM_UNITARY_VALUE<T extends BMM_UNITARY_TYPE>
  extends BMM_LITERAL_VALUE<T> {
}

/**
 * Meta-type for literals whose concrete type is a primitive type.
 */
export class BMM_PRIMITIVE_VALUE extends BMM_UNITARY_VALUE<T> {
  /**
   * Concrete type of this literal.
   */
  override type?: BMM_SIMPLE_TYPE = undefined;
}

/**
 * Meta-type for a literal Integer value, for which \`_type_\` is fixed to the \`BMM_TYPE\` representing \`Integer\` and \`_value_\` is of type \`Integer\`.
 */
export class BMM_INTEGER_VALUE extends BMM_PRIMITIVE_VALUE {
  /**
   * Native Integer value.
   */
  override value?: openehr_base.Integer = undefined;
}

/**
 * Meta-type for a literal String value, for which \`_type_\` is fixed to the \`BMM_TYPE\` representing \`String\` and \`_value_\` is of type \`String\`.
 */
export class BMM_STRING_VALUE extends BMM_PRIMITIVE_VALUE {
  /**
   * Native String value.
   */
  override value?: openehr_base.String = undefined;
}

/**
 * Meta-type for a literal Boolean value, for which \`_type_\` is fixed to the \`BMM_TYPE\` representing \`Boolean\` and \`_value_\` is of type \`Boolean\`.
 */
export class BMM_BOOLEAN_VALUE extends BMM_PRIMITIVE_VALUE {
  /**
   * Native Boolean value.
   */
  override value?: openehr_base.Boolean = undefined;
}

/**
 * Meta-type for literals whose concrete type is a linear container type, i.e. array, list or set.
 */
export class BMM_CONTAINER_VALUE extends BMM_LITERAL_VALUE<T> {
}

/**
 * Meta-type for literals whose concrete type is an indexed container, i.e. Hash table, Map etc.
 */
export class BMM_INDEXED_CONTAINER_VALUE extends BMM_LITERAL_VALUE<T> {
}

/**
 * Meta-type for literal intervals of type \`Interval<Ordered>\`.
 */
export class BMM_INTERVAL_VALUE extends BMM_LITERAL_VALUE<T> {
}
